import {catchError, filter, map, mapTo, switchMap, take, throttleTime} from 'rxjs/operators';
import axios from 'axios'
import {stTagEnsureRefreshedAction, stTagFetchAllAction, stTagResetAction} from 'module/StTag/action/StTagAction';
import {combineEpics, Epic} from 'redux-observable';
import {selStTagById, selStTagLastRefresh} from 'module/StTag/selector/StTagSelector';
import {from, interval, merge} from 'rxjs';
import moment from 'moment';
import {appInitAction} from 'util/ReduxUtil'
import _ from 'lodash'
import {auditDocumentVisible} from 'util/rxjsOperators/auditDocumentVisible'
import {alertServerError} from 'module/ConfirmDialog/component/ConfirmDialogContainer'


const InitEpic: Epic = (action$, state$) => action$.pipe(
	filter(appInitAction.match),
	take(1),
	// refresh if already used once in this app
	filter(() => !_.isEmpty(selStTagById(state$.value))),
	map(() => stTagFetchAllAction()),
)

const EnsureFetchedEpic: Epic = (action$, state$) => merge(
	action$.pipe(filter(stTagEnsureRefreshedAction.match)),
	interval(60 * 60 * 1000),
).pipe(
	auditDocumentVisible(),
	// refresh only once per day
	filter(() => selStTagLastRefresh(state$.value) < +moment().startOf('day')),
	mapTo(stTagFetchAllAction()),
)

const FetchEpic: Epic = (action$) => action$.pipe(
	filter(stTagFetchAllAction.match),
	throttleTime(60 * 1000),
	switchMap(() => {
		return from(axios.get('../json/StTag')).pipe(
			switchMap(({data}) => [stTagResetAction(data)]),
			catchError((err) => {
				void alertServerError(err, "Fehler beim Laden der Zeitmodelle")
				return []
			}),
		)
	}),
)

export const StTagEpic = combineEpics(
	InitEpic,
	EnsureFetchedEpic,
	FetchEpic,
)